import { useParams } from 'wouter'

import { KitchenPage } from '../kitchen/KitchenPage'
import { RestaurantPage } from '../restaurant/RestaurantPage'

/**
 * A channel's own *Kuchyňa* and *Otvorené stoly* - `FRONTEND.md` §9.688, owner #24 (O79).
 *
 * **The owner**: a terrace (*OFYR*) with *"samostatnú sekciu ... Otvorene stoly OFYR a KUCHYNA OFYR a tam mu bude
 * ukazovať len objednávky z terasy"*. Each is the ordinary screen told which channel it is for - one component per
 * board rather than a copy, so a fix to the kitchen reaches the terrace's kitchen by construction.
 *
 * **Keyed on the slug**, so moving from one channel's board to another's mounts a fresh screen rather than carrying
 * the last one's filter, its arrival count and its chime state across.
 */
export function ChannelKitchenPage() {
  const params = useParams<{ slug: string }>()
  const slug = params.slug ?? ''
  return <KitchenPage key={slug} boardChannel={slug} />
}

export function ChannelRestaurantPage() {
  const params = useParams<{ slug: string }>()
  const slug = params.slug ?? ''
  return <RestaurantPage key={slug} boardChannel={slug} />
}
